import {Component, Injector} from '@angular/core';
import {CategoryItemListPage} from './category-item-list';
import {MenuService} from '../../core/services/menu.service';

/*
  Generated class for the ByodSummary page.

  See http://ionicframework.com/docs/v2/components/#navigation for more info on
  Ionic pages and navigation.
*/

/**
 *   Mike: I think this page is specially used for BK?
 *
 * */
declare var genkiJSInterface: any;

@Component({
    selector: 'page-category-item-list',
    templateUrl: 'category-item-list.html',
    styleUrls: ['category-item-list.scss']
})
export class DirectCategoryItemListPage extends CategoryItemListPage {


    constructor(injector: Injector, public menuService: MenuService) {

        super(injector, menuService);
        this.t.use('en');
        this.t.currentLang = 'en';
        this.configService.setLocale('en');
        this.orderService.hiddenNav = true;
    }

    ionViewWillEnter() {
        if (!this.orderManager.order) {
            const store = this.store;
            const storeId = this.storeId;
            if (store) {
                this.store = store;
                this.storeId = store.id;
                if (this.multOrderManager.enableMutlOrder) {
                    this.settingMultiOrderManager();
                } else {
                    this.orderManager.createOrder(this.store.id, null, null, null, this.store);
                    if (this.orderManager.mode == 'byod') {
                        this.memberService.initMember('anno');
                        this.cartService.initSharingCart(this.storeId, Number.parseInt(this.orderService.spot));
                    }


                }
                this.orderManager.settingOrderType(this.orderManager.mode);

                this.getStore(this.orderManager.mode);

            } else if (storeId) {
                this.storeId = storeId;
                if (this.multOrderManager.enableMutlOrder) {
                    this.settingMultiOrderManager();
                } else {
                    this.orderManager.createOrder(this.store.id, null, null, null, this.store);
                    if (this.orderManager.mode == 'byod') {
                        this.memberService.initMember('anno');
                        this.cartService.initSharingCart(this.storeId, Number.parseInt(this.orderService.spot));
                    }

                }

                this.orderManager.settingOrderType(this.orderManager.mode);
                this.getStore(this.orderManager.mode);


            }
        }
    }

    getStore(type?: string): void {

        this.loading(true);

        this.menuService.getBKStore(this.storeId, true, type).subscribe(
            store => {
                this.store = store;
                this.paymentService.preload(this.store, () => {
                    this.paymentService.checkPaymentMethodAvailable();
                });

                console.log(this.store);
                this.orderService.isBK = store.brand.id == 800001;
                this.setTheme(store.brand, store);
                const [stopped, period] = this.stoppedPreOrder(store);
                if (stopped || !period) {
                    this.loading(false);
                    const message = store.closedMessage ? store.closedMessage : this.t.instant('global.no-service-message');
                    this.showAlert('', message, [{
                        text: this.t.instant('buttons.ok'),
                        handler: () => {
                            genkiJSInterface.exitwebview();

                        }
                    }]);
                } else {
                    this.saveWeekDay(period);
                    this.monitoringService.listenStoreKioskStatus(store, () => {
                        this.loading(false);
                        this.showAlert('', this.t.instant('global.kiosk-offline-message'), [{
                            text: this.t.instant('buttons.ok'),
                            handler: () => {
                                genkiJSInterface.exitwebview();

                            }
                        }]);
                    }, () => {
                        this.loading(false);
                        this.showStore(store);
                    });

                }
                // this.showStore(store);
            },
            err => console.error(err),
            () => {
                this.loading(false);
            }
        );

    }

    protected isTempAccessPage(): boolean {
        return true;
    }

}
